import zando from "./assets/zando.JPG";
import ten11 from "./assets/ten11.JPG";

import { AiOutlineFacebook, AiOutlineInstagram, AiOutlineLinkedin, AiOutlineGithub } from "react-icons/ai";

export const projectData = [
    {
        id: 1,
        name: "Zando mobile application",
        img: zando,
        company: "ZANDO",
        role: "Software developer",
        accomplishment: [
            "Develop new features",
            "Improve performance",
            "Research",
            "Integrate with google and facebook sdk and more",
        ],
    },
    {
        id: 2,
        name: "Ten11 mobile application",
        img: ten11,
        company: "ZANDO",
        role: "Software developer",
        accomplishment: ["Develop new features", "Improve performance", "Research"],
    },
    {
        id: 3,
        name: "Zando web application",
        img: zando,
        company: "ZANDO",
        role: "Software developer",
        accomplishment: ["Develop new features", "Improve performance", "Research"],
    },
    {
        id: 4,
        name: "Ten11 web application",
        img: ten11,
        company: "ZANDO",
        role: "Software developer",
        accomplishment: ["Develop new features", "Improve performance", "Research"],
    },
];

export const blogs = [
    {
        name: "React Native Code Push Custom Server",
        describe:
            "Developers can deliver JavaScript files, such as hot fixes for bugs and new little features, to users' devices using code-push instead of submitting them to Google Play and the App Store.",
        link: "code_push",
    },
];

export const link = [
    {
        icon: <AiOutlineFacebook />,
        url: "https://www.facebook.com/mizter.dom",
    },
    {
        icon: <AiOutlineInstagram />,
        url: "https://www.instagram.com/eav_out_dom",
    },
    {
        icon: <AiOutlineLinkedin />,
        url: "https://www.linkedin.com/in/eav-outdom-2b8496210/",
    },
    {
        icon: <AiOutlineGithub />,
        url: "https://github.com/EavOutDom",
    },
];

export const skills = [
    {
        title: "Programming Languages, Frameworks and Technologies",
        list: [
            { name: "React Native", level: 9 },
            { name: "Next.js", level: 8 },
            { name: "ReactJS", level: 9 },
            { name: "JavaScript", level: 9 },
            { name: "TypeScript", level: 6 },
            { name: "Node.js", level: 7 },
            { name: "ExpressJS", level: 7 },
            { name: "MongoDB", level: 5 },
            { name: "Tailwind CSS", level: 9 },
            { name: "Laravel", level: 5 },
            { name: "Ant Design", level: 8 },
            { name: "MUI", level: 5 },
            { name: "Java", level: 5 },
            { name: "Grails", level: 7 },
            { name: "SQL", level: 7 },
            { name: "Git", level: 8 },
            { name: "SVN", level: 8 },
            { name: "Firebase", level: 6 },
        ],
    },
    {
        title: "Development and Management Tools",
        list: [
            { name: "Visual Studio Code", level: 10 },
            { name: "JetBrains", level: 8 },
            { name: "MySQL", level: 6 },
            { name: "JIRA", level: 7 },
            { name: "Github", level: 8 },
        ],
    },
    {
        title: "Operating Systems",
        list: [
            { name: "Windows 10 and 11", level: 9 },
            { name: "Mac", level: 7 },
            { name: "Ubuntu", level: 6 },
        ],
    },
];
